import React, { type FC } from 'react'
import { TableBody, TableCell, TableRow, Typography, Checkbox } from '@mui/material'

const styles = {
  checkbox: {
    color: '#909090'
  },
  tableCell: {
    backgroundColor: '#272727',
    borderBottom: 'none',
    padding: '5px'
  },
  tableCellTypography: {
    color: '#F0F0F0',
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: 'Honeywell Sans Web',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    borderBottom: 'none'
  }
}

const EmptyTable: FC = () => {
  return (
    <>
      <TableBody>
        <TableRow>
          <TableCell sx={styles.tableCell}>
            <Checkbox
              color="primary"
              checked={false}
              sx={styles.checkbox}
              size="small"
            />
          </TableCell>
          <TableCell colSpan={6} sx={styles.tableCell}>
            <Typography sx={styles.tableCellTypography}>
              No Records found
            </Typography>
          </TableCell>
        </TableRow>
        {[...Array(7)].map((_, index) => (
          <TableRow key={index}>
            <TableCell sx={styles.tableCell}>
              <Checkbox
                color="primary"
                checked={false}
                sx={styles.checkbox}
                size="small"
              />
            </TableCell>
            <TableCell colSpan={6} sx={styles.tableCell}>
              <Typography sx={styles.tableCellTypography}>
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  )
}

export default EmptyTable
